$(window).on('load resize', fullWidthContainer);

function fullWidthContainer() {
    var $elements = $('body:not(.mxm_unigrid-editmode) .row-fullwidth-container');

    $.each($elements, function (key, item) {
        var $el = $(this);
        var $parent = $el.parent();
        var offset = $parent.offset().left;

        if ($el.children('.container').length == 0) {
            // $el.wrapInner('<div class="row"></div>');
            $el.wrapInner('<div class="container"></div>');
        } else {
            $el.find('> .container').css({
                "max-width": $parent.outerWidth(),
                "margin-left": offset
            })
        }
        $el.css({
            left: -offset,
            position: "relative",
            width: $(window).innerWidth()
        });
    });
}
